import { CSSProperties, ReactNode } from 'react';
import {
  PlacesType,
  PositionStrategy,
  Tooltip,
  VariantType
} from 'react-tooltip';

export type TooltipType = 'text' | 'custom';

interface CustomTooltipProps {
  id: string; // unique key to identify each tooltip
  type?: TooltipType;
  className?: string;
  place?: PlacesType; // tooltip position
  opacity?: CSSProperties['opacity']; // opacity for tooltip
  variant?: VariantType; // tooltip variant
  clickable?: boolean; // is tooltip clickable inside
  tooltipText?: string; // for type='text'
  showTooltip?: boolean; // to show tooltip onClick
  children?: ReactNode; // for type='children'
  noArrow?: boolean;
  float?: boolean; // tooltip follows the cursor instead of anchoring to the element
  hidden?: boolean; // hide the tooltip even while its anchor is hovered
  positionStrategy?: PositionStrategy; // 'fixed' escapes an ancestor's overflow clipping
}

const CustomTooltip = (props: CustomTooltipProps) => {
  const {
    id,
    type,
    className,
    place = 'top',
    opacity = 1,
    variant = 'dark',
    clickable = false,
    tooltipText,
    showTooltip,
    children,
    noArrow = true,
    float = false,
    hidden = false,
    positionStrategy = 'absolute'
  } = props;
  const renderTooltip = () => {
    const tooltipContent = type === 'text' ? tooltipText : children;

    return (
      <Tooltip
        id={id}
        noArrow={noArrow}
        className={`z-40 !rounded-lg !text-sm !font-normal ${className || ''}`}
        opacity={opacity}
        place={place}
        variant={variant}
        clickable={clickable}
        float={float}
        hidden={hidden}
        positionStrategy={positionStrategy}
        isOpen={showTooltip && showTooltip}
      >
        {tooltipContent}
      </Tooltip>
    );
  };

  return renderTooltip();
};

export default CustomTooltip;
